import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'
import { compose } from 'redux'

import { EnhancedModalBase } from './EnhancedModal'

import { modalTypeSelector, modalStateSelector } from 'reduxModules/selectors/ModalSelectors'
import { modalActions } from 'reduxModules/actions/ModalActions'
import { bookActions } from 'reduxModules/actions/BookActions'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  modalType: modalTypeSelector,
  modalState: modalStateSelector,
})

const mapDispatchToProps = {
  hideModal: modalActions.hideModal,
  cancelAction: modalActions.cancelAction,
  confirmAction: modalActions.confirmAction,
  addSavedBooking: bookActions.addSavedBooking,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const EnhancedModal = enhance(EnhancedModalBase)


// WEBPACK FOOTER //
// ./src/components/EnhancedModal/index.js